export enum ResourceType {
    None = 0,
    Dozent = 1,
    Raum = 2,
    Gerät = 3
}

export abstract class ResourceTypeHelper {

    /**
     * Returns a string representation of ResourceType
     *
     * @static
     * @param {ResourceType} type
     * @returns {string}
     * @memberof ResourceTypeHelper
     */
    static getString(type: ResourceType): string {
        switch (type) {
            case ResourceType.None:
                return 'None';
            case ResourceType.Dozent:
                return 'Teacher';
            case ResourceType.Raum:
                return 'Room';
            case ResourceType.Gerät:
                return 'Device';
            default:
                throw new Error(`Invalid ResourceType: '${type}'`);
        }
    }
}
